import http from "../http"

class CompanyAnniversaryService {

    async getCalendar(data) {
        const rqst = await http.post('/company-anniversaries/calendar/', data)
        return rqst.data
    }

    async getUpcoming(data) {
        const rqst = await http.post('/company-anniversaries/upcoming/', data)
        return rqst.data
    }

    async getLogs(data) {
        const rqst = await http.post('/company-anniversaries/logs/', data)
        return rqst.data
    }

    async getConfig(data) {
        const rqst = await http.post('/company-anniversaries/config/', data)
        return rqst.data
    }

    async updateConfig(data) {
        const rqst = await http.put('/company-anniversaries/config/', data)
        return rqst.data
    }
}

const companyAnniversaryService = new CompanyAnniversaryService()
export default companyAnniversaryService
